import { PropType, defineComponent } from "vue";
import { DictionaryTableNote, SdkTableColumn, SdkTableColumnConstraint } from "@/interfaces/sdk-dictionary";
import { loadConstraints } from "@/store/dictionary/actions";
import { EventBus } from "@/utils/event-bus";

export default defineComponent({
  name: "sdk-dictionary-table-column",
  props: {
    column: {
      type: Object as PropType<SdkTableColumn>,
      required: true,
    },
    tableName: String,
    owner: String,
    createdNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
      required: true,
    },
    deleteNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
      required: true,
    },
    viewNotes: {
      type: Array as PropType<DictionaryTableNote[]>,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      constraints: [] as SdkTableColumnConstraint[],
    };
  },
  computed: {
    hasConstraints(): boolean {
      const { typeKey } = this.column;
      return typeKey === "R";
    },
  },
  methods: {
    async loadConstraints() {
      this.loading = true;
      this.$dispatch(loadConstraints)([this.owner, this.tableName, this.column.name, this.$route.params.system, this.$route.params.version]).then(
        (data: any) => {
          this.constraints = data;
          this.loading = false;
        }
      );
    },
    async referenceTable() {
      this.loading = true;
    },
    async loadNotesModal() {
      const parameters = {
        openModal: true,
        column: this.column,
        tableName: this.tableName,
        owner: this.owner,
        createdNotes: this.createdNotes,
        deleteNotes: this.deleteNotes,
      };
      EventBus.$emit("open-modal", parameters);
    },
    createdNotesPermission(): boolean {
      return this.createdNotes.length > 0 || this.deleteNotes.length > 0;
    },
    hasNotes(): boolean {
      return !(this.column.notes.length > 0 && this.viewNotes.length > 0);
    },
  },
});
